import React from 'react';

import HStack from '../../../../HStack/HStack';
import Button from '../../../../Button/Button';
import PrimaryAction from '../../PrimaryAction/PrimaryAction';
import { PrimaryActionType, SecondaryActionType, TertiaryActionType } from '../../../Block';

export interface DesktopMultiActionsProps {
  actionSize?: 'wide' | 'full';
  actionIsLoading?: boolean;
  primaryAction?: PrimaryActionType;
  secondaryAction?: SecondaryActionType;
  tertiaryAction?: TertiaryActionType;
  formId?: string | undefined;
}

const DesktopMultiActions = ({
  actionSize,
  actionIsLoading,
  secondaryAction,
  tertiaryAction,
  primaryAction,
  formId,
}: DesktopMultiActionsProps) => (
  <HStack align="distributed">
    <Button
      data-testid={secondaryAction?.['data-testid']}
      isLoading={actionIsLoading}
      onClick={secondaryAction?.callback}
      {...secondaryAction}
    >
      {secondaryAction?.label}
    </Button>
    <HStack align="distributed" spacing="medium">
      {Boolean(tertiaryAction?.label) && (
        <Button
          data-testid={tertiaryAction?.['data-testid']}
          isLoading={actionIsLoading}
          type="transparent"
          onClick={tertiaryAction?.callback}
        >
          {tertiaryAction?.label}
        </Button>
      )}
      <PrimaryAction
        {...primaryAction}
        actionIsLoading={actionIsLoading}
        size={actionSize || primaryAction?.size}
        formId={formId}
      />
    </HStack>
  </HStack>
);

export default DesktopMultiActions;
